import {AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid, parseOptions} from '../question-helper';
import { SlickCarouselComponent } from "ngx-slick-carousel";
import { QuestionFlowSessionQuery } from '../state/question-flow-session.query';
import { RouterLinks } from '../../constants';
import { Router } from '@angular/router';
import { ShoppingCartStore } from '../state/shopping-cart-store';
import { set } from 'lodash';
import { Subscription } from 'rxjs';

declare var $: any;
declare function isElementInViewport(c: any, a: boolean): any;
declare function editModalGuides(): any;
declare function initReadMore(): any;
@Component({
    selector: 'app-question-super-traffic-cop',
    templateUrl: './question-super-traffic-cop.component.html',
    styleUrls: ['./question-super-traffic-cop.component.scss'],
    standalone: false
})

export class QuestionSuperTrafficCopComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() labelText = '';
  @Input() placeHolderText = '';
  @Input() value = '';
  @Input() showToolTip = true;
  @Input() toolTipContent = 'To change this answer you need to restart or contact us';
  @Input() toolTipPlacement = 'bottom';
  @Input() isToolTipContentHtml = false;
  @Input() items: any[] = [];
  @Input() selectedOption: any;
  @Input() selectedLocation: any;
  @Output() questionAnswer = new EventEmitter();
  @Output() showEditModal = new EventEmitter<any>();
  @Output() locationExits = new EventEmitter<any>();
  @Output() enableButtonFromChild = new EventEmitter<any>();
  @Output() submit = new EventEmitter<void>();
  @ViewChild("slickModal") slickModal: SlickCarouselComponent;

  classes: any;
  grouping: any[] = [];
  nonLocation: any[] = [];
  uniqueControlName = `textbox-${newGuid()}`;
  uniqueId = `textbox-${newGuid()}`;
  slideConfig = {
    dots: true,
    arrows: false,
    variableWidth: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    swipeToSlide: true,
    prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    rows: 0,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };
  trafficConfig = {
    dots: true,
    arrows: true,
    fade: true,
    speed: 400,
    cssEase: "ease-in",
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    rows: 0
  };
  session_details: any;
  classCount = 0;
  locations: any [] = [];
  selectSection: any;
  selectedItem: any;
  removeModal: any;
  summaryDataSubscription: Subscription;
  constructor(public questionService: GlobalQuestionService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private shoppingCartStore: ShoppingCartStore,
    private ref: ChangeDetectorRef,
    private router: Router,
    ) {
    this.questionService.spinner(true);
    this.session_details = this.questionFlowSessionQuery.getValue();
  }
  
  ngOnInit(): void {
   this.getSuperTrafficCop();
    this.summaryDataSubscription = this.questionService.summaryData
      .subscribe(v => {
        if (v) {
          //if (!this.isSavingData) {
            this.getSuperTrafficCop();
          //}
          this.questionService.setSummaryDataObservable(false);
        }
      });
    
  }
  getSuperTrafficCop(): void{
    const parameters = new Map<string, string>();
    this.nonLocation = [];
    this.questionService.spinner(true);
    parameters.set('session_id', this.session_details?.session_id);
    //parameters.set('location_id', this.selectedOption?.location_id?.toString());
    this.questionService.runCommandNew(`getSuperTrafficCop`, parameters)
      .subscribe(classes => {
        this.classes = classes;
        console.log(this.classes);
        this.classCount = this.classes.filter(c => c.group_id > 0).length;
        if (this.classCount === 1) {
          //$('#next-question-label').text('Next');
        }
        this.items = classes;

        this.items.forEach(i => {
          if (i?.item_detail !== '') {
            i.item_detail = JSON.parse(i?.item_detail);
          }
          if (this.grouping.filter(g => g.group_id === i.group_id).length === 0 && i.group_id !== 4 && i.cent_aq_answer_id !== 0) {
            this.grouping.push(i);
          }
          if (this.locations.filter(l => l.location_id === i.location_id).length === 0 && i.location_id !== 0) {
            this.locations.push({ location_id: i.location_id, location_name: i.location_name });
          }
        });
        this.nonLocation = this.items.filter(i => i.group_id === 4);
        console.log(this.grouping)
        if (this.locations?.length > 0) {
          this.locationExits.emit({ locations: this.locations, classes: this.classes, grouping: this.grouping, nonlocation: this.nonLocation });
          //Handle location modal logic
          let loc = { session_id: '', locationModalShown: false };
          try {
            loc = JSON.parse(localStorage.getItem('locationModalShown'))
          }
          catch { }
          if (!loc) {
            $('#splash-modal').modal('show');
            loc = { session_id: this.session_details?.session_id, locationModalShown: true };
            localStorage.setItem('locationModalShown', JSON.stringify(loc));
          }
          else {
            if (loc?.session_id !== this.session_details?.session_id && loc?.locationModalShown === false) {
              $('#splash-modal').modal('show');
              loc.session_id = this.session_details?.session_id;
              loc.locationModalShown = true;
              localStorage.setItem('locationModalShown', JSON.stringify(loc));
            }
          }
        }
        this.checkIfItemExists();
        setTimeout(() => {
          this.questionService.spinner(false);
          //this.initCoverSlider();
          initReadMore();
          let disabled = this.items.find(i => i.group_id == null)?.disabled;
    
          this.enableButtonFromChild.emit(disabled == 1)
        }, 2000);
      });
  }
  filterClassByLocation(): void {
    this.items = this.classes?.filter(i => i.location_id === this.selectedLocation?.location_id);

    this.locationExits.emit({ locations: this.locations, classes: this.items, grouping: this.grouping, nonlocation: this.nonLocation });
  }
  ngOnChanges(changes: SimpleChanges): void {

    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      this.items = parseOptions(this.question?.options);
    } else if (changes?.items?.currentValue) {
      this.items = changes?.items?.currentValue;
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
    if (changes?.selectedOption?.currentValue !== changes?.selectedOption?.previousValue) {
      this.selectedOption = changes?.selectedOption?.currentValue;
    }
    if (changes?.selectedLocation?.currentValue !== changes?.selectedLocation?.previousValue) {
      this.selectedLocation = changes?.selectedLocation?.currentValue;
    }

    this.filterClassByLocation();
    setTimeout(() => {
      this.questionService.setShoppingCart(this.question);
    }, 2000);
  }
  addAnother(c: any): void {
    this.question.answer = c.answer;
    $('#next-question-label').text('Next');
    this.questionAnswer.emit(this.question);
    this.submit.emit();
    setTimeout(() => {
      // this.question.answer = 'Nothing More';
      // this.questionAnswer.emit(this.question);
       $('#next-question-label').text('View quote summary');
    }, 5000);
  }
  checkRadio(level: any, event): void {
    if (this.classCount === 1) {
      $('#next-question-label').text('Next');
      return;
    }
    $('.custom-traffic').removeClass('is-checked');

    if ($(`.${level.cent_aq_answer_id}`).hasClass('is-checked')) {
      $('.custom-traffic:not(".is-included"):not(".is-active")')
        .removeClass('is-checked')

        // and uncheck any groups
        .closest('.custom-traffic__group')
        .removeClass('is-checked');
      $(`.${level.cent_aq_answer_id}`).removeClass('is-checked');
      if (this.question) {
        //this.question.answer = 'Nothing More';
        //this.questionAnswer.emit(this.question);
        $('#next-question-label').text('View quote summary');
      } else {
        this.questionAnswer.emit(level.answer);
      }
    }
    else {

      $(`.${level.cent_aq_answer_id}`).addClass('is-checked');
      if (this.question) {
        this.question.answer = level.answer;
        this.question.location_id = level.location_id;
        this.questionAnswer.emit(this.question);
        $('#next-question-label').text('Next');
      } else {
        this.questionAnswer.emit(level.answer);
      }
    }
    if (event) {
      if (event?.srcElement?.checked) {
        this.question.answer = level.answer;
        this.questionAnswer.emit(this.question);
        $('#next-question-label').text('Next');
      }
      else {
        //this.question.answer = 'Nothing More';
        //this.questionAnswer.emit(this.question);
        $('#next-question-label').text('View quote summary');
      }
    }
    console.log(level);
    this.selectedOption = level;
    this.checkIfItemExists();

  }
  ngAfterViewInit(): void {
    $("#splash-modal").on("hidden.bs.modal", function (e) {
      editModalGuides()?.init(null, 1);
    });
    $('#page-canvas').removeClass('quote-progress-active');

  }
  getGroupingClasses(group: any, c: any): any {
    
    if (this.classCount === 1) {
      return this.items.filter(g => g.group_id === group.group_id && g.group_id !== 4 && g?.level === 1);
    }
    else {
      if (c) return this.items.filter(g => g.group_id === group.group_id && g.group_id !== 4 && g.parent_answer_id === c.cent_aq_answer_id && g.location_id === this.selectedLocation?.location_id);
      else if (this.selectedLocation){
          return this.items.filter(g => g.group_id === group.group_id && g.group_id !== 4 && g.location_id === this.selectedLocation?.location_id && g?.level === 1);
      } 
      else 
        return this.items.filter(g => g.group_id === group.group_id && g.group_id !== 4  && g?.level === 1);
    }
  }
  getItk(l: any): any {
    if (!l) return [];
    if (l._itkParsed !== undefined) {
      return l._itkParsed;
    }
    try {
      l._itkParsed = JSON.parse(l.itk);
    }
    catch {
      l._itkParsed = [];
    }
    return l._itkParsed;
  }
  upperCase(): void {
    if (this.question?.cent_aq_question_id === 57 || this.question?.cent_aq_question_id === 2501) {
      this.value = this.value.toUpperCase();
    }
  }

  saveValue(): void {
    if (this.question) {
      this.question.answer = this.value;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(this.value);
    }
  }
  initCoverSlider(): void {
    var $slider = $("#cover-slider");
    
    if ($slider.length === 0) {
      console.warn("#cover-slider not found when initializing slider");
      return;
    }
    
    // If already initialized, destroy it first
    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("unslick");
      $('.slick-container').slick('removeSlide', null, null, true);
    }
    else {
      
      $slider.slick({
        dots: true,
        arrows: false,
        variableWidth: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
        rows: 0,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }
  initSliders(): void {
         var accordionsOpen = false;
      // only listen for non-included and non-activated controls
      $(document).on('click', '.custom-traffic:not(".is-included"):not(".is-active") .custom-traffic__label', function(){
         
         var $controlLabel = $(this);
         var $control = $controlLabel.closest('.custom-traffic');
         var $controlGroup = $control.closest('.custom-traffic__group');
      
         // if not already checked
         // and if no active controls of the same name exist
         if( !$control.hasClass('is-checked') ){

            // find other controls, and uncheck 'em all 
            $('.custom-traffic:not(".is-included"):not(".is-active")')
               .removeClass('is-checked')

               // and uncheck any groups
               .closest('.custom-traffic__group')
               .removeClass('is-checked');

            // check control
            $control.addClass('is-checked');

            // and check active group if exists
            if($controlGroup){
               $controlGroup.addClass('is-checked');
            }

         } else {

            // uncheck control
            $control.removeClass('is-checked');

            // and and uncheck group if exists
            if($controlGroup){
               $controlGroup.removeClass('is-checked');
            }

         }         

      });
    
      // on remove of active item...
      // convert to standard state
      var $itemToDeactivate = null;            

      // $('#remove-alert-modal').on('show.bs.modal', function(e){
      //    var $trigger = $(e.relatedTarget);
      //    $itemToDeactivate = $trigger.closest('.custom-traffic');
      // });

      // $(document).on('click', '#remove-cover-btn', function(e){       
      //    $itemToDeactivate
      //       .removeClass('is-active')
      //       .find('.custom-traffic__indi').html('<span class="fake-radio"></span>');

      //    $itemToDeactivate.closest('.custom-traffic__group')
      //       .removeClass('is-active').removeClass('is-checked')
      //       .find('.custom-traffic--child').removeClass('is-active').removeClass('is-checked');            
      // });
      

      // sliders
    //   $('.slider--traffic').each(function () {
    //     var $slider = $(this);

    //     $slider.slick({
    //        dots: true,
    //        arrows: true,
    //        fade: true,
    //        speed: 400,
    //        cssEase: "ease-in",
    //        infinite: false,
    //        slidesToShow: 1,
    //        slidesToScroll: 1,
    //        swipeToSlide: true,
    //        prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    //        nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    //        rows: 0
    //     });

    //     // // carousel refresh on accordion open (else it's all broken-like ...probably fine when using angular version tho)
    //     // $slider.closest('.accordion__body').on('show.bs.collapse', function (e) {
    //     //    // $slider.slick('refresh'); 
    //     // });


    //  });
   
  }
  reloadQuestion(q:any): void {
    this.grouping = [];
    this.question = q;
    this.items = parseOptions(q?.options);
    setTimeout(() => {
      //this.questionAnswer.emit(q);
    }, 5000);
    
    //this.ngOnInit();
    //window.location.reload();
    //this.questionAnswer.emit(this.question);
    // this.items.forEach(i => {
    //   if (!this.grouping.includes(i.group_name))
    //     this.grouping.push(i.group_name);
    // });
  }

  editModal(event: any, item_id = 1): void {
    if (item_id === 0) item_id = 1;
    event.item_id = item_id;
    console.log(event);
    this.questionService.spinner(true);
    let collation: any;
      this.questionService.updatePrices(this.question?.product_id, this.question?.product_class_id, 0)
        .subscribe(x => {
          this.questionService.getPageData('quote')
            .subscribe(dataset => {
              console.log(dataset);
              let product = this.questionService.getIndexData(4, dataset).find(p => p.product_id === this.question?.product_id);              
              let person = this.questionService.getIndexData(1, dataset)[0];
              let collations = this.questionService.getIndexData(2, dataset);
              let locations = this.questionService.getIndexData(15, dataset);

              collation = collations.find(c => c.class_id === event?.class_id && c.session_item_id.toString() === event?.item_id.toString() && c.product_id === product?.product_id);
              console.log('item', event);
              console.log('product', product);
              console.log('collation', collation);
              console.log('collations', collations);

              this.showEditModal.emit({
                collations: collations,
                collation,
                product: product,
                person: person,
                locations: locations,
                path: '3'
              });
            }, error => {
              console.log(error);
              this.questionService.spinner(false);
            });
        }, () => {
          this.questionService.spinner(false);
        });
    
  }
  checkIfItemExists(): void {
    this.enableButtonFromChild.emit(true);
    let itemExists = false;
    this.items.forEach(item => {
      if (item?.item_detail){
        itemExists = true;
      }
    });
    if (itemExists || this.question.answer){
      this.enableButtonFromChild.emit(false);
    }
    else if (!itemExists && !this.question.answer){
      this.enableButtonFromChild.emit(true);
    }
    else if (itemExists || !this.question.answer){
      this.question.answer = this.selectedOption?.answer
      this.questionAnswer.emit(this.question);
      this.enableButtonFromChild.emit(false);
    }
    
  }
  hasItems(group: any): boolean {
    if ( this.items.filter(g => g.group_id === group.group_id && g.item_detail?.length > 0 && g.location_id === this.selectedLocation?.location_id)?.length > 0){
      return true;
    }
    else {
      return false;
    }
  }
  removeClassItem(c: any, i: string): void {
    console.log(c, i);
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.session_details?.session_id);
    parameters.set('class_id', c.class_id);
    parameters.set('item_id', i);
    parameters.set('location_id', c?.location_id?.toString());
    this.questionService.runCommandNew(`removeClassItem`, parameters)
      .subscribe(response => {
        this.getSuperTrafficCop();
        setTimeout(() => {
          this.questionService.setShoppingCart(this.question);
        }, 1000);
      })
  }
  nothinMore(event: any): void {
    console.log(event)
  }
}
